/**
 * @description Centralized query keys for facturas module
 * @author Omar Sánchez Martínez
 * @since 22/08/2025
 */

import type { FacturaUIFilters } from '../types/facturaFilters.interface';

export const facturasKeys = {
  // Base key for all facturas queries
  all: () => ['facturas'] as const,

  // List queries with parameters
  lists: () => [...facturasKeys.all(), 'list'] as const,
  list: (params: FacturaUIFilters) => [...facturasKeys.lists(), params] as const,

  // Detail queries
  details: () => [...facturasKeys.all(), 'detail'] as const,
  detail: (id: number) => [...facturasKeys.details(), id] as const,

  // Search queries (for consistency with legacy POST /facturas/search)
  searches: () => [...facturasKeys.all(), 'search'] as const,
  search: (params: FacturaUIFilters) => [...facturasKeys.searches(), params] as const,

  // Pre-facturas specific queries
  preFacturas: () => [...facturasKeys.all(), 'pre-facturas'] as const,
  preFactura: (id: number) => [...facturasKeys.preFacturas(), id] as const,

  // Comprobante actions queries (for sharing, download history, etc.)
  actions: () => [...facturasKeys.all(), 'actions'] as const,
  action: (actionType: string, id: number) => [...facturasKeys.actions(), actionType, id] as const,
} as const;
